<template>
  <div id="app">
    <v-card color="grey lighten-5" flat>


      <v-container fluid>
        <v-layout row wrap>

          <v-flex xs12 sm12 md12>
            <v-layout style="page-break-after: always;" row wrap>


              <div id="printJS-form">





                <v-flex  xs12 pl-1 sm12 md12>
                  <v-layout row wrap class="pl-1 pr-1 project overdue">
                    <v-toolbar flat="" size="120px" dark color="white">
                      <v-toolbar-title> <span class="subheading black--text">
                          Bilet Detayı
                        </span> </v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-tooltip bottom>
                        <v-btn slot="activator" @click="yazdir('printJS-form')" flat> <span class="hidden-sm-and-down">
                            Yazdır
                          </span>
                          <v-icon class="no-print" color="grey" right dark>print</v-icon>
                        </v-btn>
                        <span>Yazdır</span>

                      </v-tooltip>
                    </v-toolbar>
                  </v-layout>
                </v-flex>

                <v-flex xs12 sm12 md12 pa-1>
                  <v-card flat>
                    <v-layout row wrap class="pa-3 project overdue">
                      <v-flex pt-1 pb-3 sm112 xs12 md12>
                        <v-layout row wrap>
                          <v-flex pa-1 sm10 xs12 md9>
                            <div class="subheading-2 font-weight-	  black--text">
                              <v-icon class="no-print" color="grey">account_box </v-icon> &nbsp; Yolcu Bilgileri
                            </div>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                      <v-flex xs12 md12>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex pa-1 sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Yolcu Adı</div>
                                </v-layout>
                              </v-flex>

                              <v-flex pa-1 xs10 md10>
                                <v-layout justify-start>
                                  <div class="justify-end align-center  grey--text fill-height subheading ">
                                    : {{Bilet.GenelBilgileri.YolcuAdi}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex pa-1 sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Bilet Alış Tarihi</div>
                                </v-layout>
                              </v-flex>

                              <v-flex pa-1 xs10 md10>
                                <v-layout justify-start>
                                  <div class="justify-end align-center  grey--text fill-height subheading ">
                                    : {{Bilet.TarihBilgileri.SatisTarihi | dateformat}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex pa-1 sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Rezervasyon Veren</div>
                                </v-layout>
                              </v-flex>

                              <v-flex pa-1 xs10 md10>
                                <v-layout justify-start>
                                  <div class="justify-end align-center  grey--text fill-height subheading ">
                                    : {{Bilet.GenelBilgileri.RezervasyonVeren}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex pa-1 sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Rezervsayon Alan</div>
                                </v-layout>
                              </v-flex>

                              <v-flex pa-1 xs10 md10>
                                <v-layout justify-start>
                                  <div class="justify-end align-center  grey--text fill-height subheading ">
                                    : {{Bilet.GenelBilgileri.RezervasyonAlan}}</div>
                                </v-layout>
                              </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                    </v-layout>

                  </v-card>


                </v-flex>

                <v-flex xs12 sm12 md12 pa-1>
                  <v-card flat>
                    <v-layout row wrap class="pa-3 project overdue">
                      <v-flex pt-1 pb-3 sm112 xs12 md12>
                        <v-layout row wrap>
                          <v-flex pa-1 sm10 xs12 md9>
                            <div class="subheading-2 font-weight-	  black--text">
                              <v-icon class="no-print" color="grey">local_airport </v-icon> &nbsp; Bilet Bilgileri
                            </div>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                      <v-flex xs12 md12>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Havayolu Kodu</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        : {{havayolobilgisi}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Bilet No</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        : {{Bilet.GenelBilgileri.BiletNo}}</div>
                                    </v-layout>
                                  </v-flex>

                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Uçuş Tip</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        : {{Bilet.GenelBilgileri.UcusTipi | ucustipi}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Referans</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        :
                                        {{Bilet.GenelBilgileri.Referans.Kod}}-{{Bilet.GenelBilgileri.Referans.ReferansAd}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Fatura Tarihi</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        : {{Bilet.FaturaBilgileri.FaturaTarihi | dateformat}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-1 xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Fatura Seri/No</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                        : {{Bilet.FaturaBilgileri.FaturaSeri}} {{Bilet.FaturaBilgileri.FaturaNo}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                    </v-layout>

                  </v-card>


                </v-flex>

                <v-flex xs12 sm12 md12 pa-1>
                  <v-card flat>
                    <v-layout row wrap class="pa-3 project overdue">
                      <v-flex pt-1 pb-3 sm112 xs12 md12>
                        <v-layout row wrap>
                          <v-flex pa-1 sm10 xs12 md9>
                            <div class="subheading-2 font-weight-	  black--text">
                              <v-icon class="no-print" color="grey">flight_takeoff </v-icon> &nbsp; Parkur Bilgileri
                            </div>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                      <v-flex xs12 md12>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Parkur</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Uçuş Tarihi</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Saat</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Havayolu</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Uçuş No</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">Aktarma</div>
                                </v-layout>
                              </v-flex>

                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex v-for="item in Bilet.UcusBilgileri.UcusListesi" :key="item.id" xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.Parkur}}</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.UcusTarihi | dateformat}}
                                  </div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.UcusSaat}}</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.UcusHY}}</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.UcusNo}}</div>
                                </v-layout>
                              </v-flex>

                              <v-flex sm2 xs2 md2>
                                <v-layout justify-left>
                                  <div class="subheading	 justify-start   grey--text">{{item.Aktarma | aktarma}}</div>
                                </v-layout>
                              </v-flex>

                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>




                        </v-layout>
                      </v-flex>

                    </v-layout>

                  </v-card>


                </v-flex>


                <v-flex xs12 sm12 md12 pa-1>
                  <v-card flat>
                    <v-layout row wrap class="pa-3 project overdue">
                      <v-flex pt-1 pb-3 sm112 xs12 md12>
                        <v-layout row wrap>
                          <v-flex pa-1 sm10 xs12 md9>
                            <div class="subheading-2 font-weight-	  black--text">
                              <v-icon class="no-print" color="grey">note_add </v-icon> &nbsp; Bilet Tutar Bilgileri
                            </div>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                      <v-flex xs12 md12>
                        <v-layout row wrap>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Bilet Tutar</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                         {{Bilet.TutarBilgileri | bilettutar}}{{getparabirimi()}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Servis</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.ServisTutar.ServisTutar | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>

                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                                <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">YFF</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.YFFTutar.YFFTutar | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Iskonto</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.IskontoTutar.IskontoTutar | moneyformat}}{{getparabirimi()}}
                                      </div>

                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout  justify-start>
                                      <div class="subheading	 justify-start   grey--text">Alan Vergisi</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.AlanVergiTutar.AlanVergiTutar | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-1 xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Toplam Servis</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                         {{Bilet.TutarBilgileri | toplamservis}}{{getparabirimi()}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

 <v-flex xs12 v-if="Bilet.GenelBilgileri.UcusTipi=='B'" sm12 md12>
                            <v-layout row wrap>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Tax</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.TaxTutar.TaxTutar | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex pb-1 xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">&nbsp;</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                       &nbsp;
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>


                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>





                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">Toplam Vergi</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                         {{Bilet.TutarBilgileri | toplamvergi}}{{getparabirimi()}}</div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                              <v-flex pb-1 xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text">KDV</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout  justify-end>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.NetTutar.NetTutarKdv | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>


                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>























                          <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                              <v-flex pb-3 pt-3 xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start   grey--text"></div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-start>
                                      <div class="justify-end align-center  grey--text fill-height subheading ">
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>

                              <v-flex xs6 sm6 md6>
                                <v-layout row wrap>
                                  <v-flex pa-1 sm4 xs4 md4>
                                    <v-layout justify-left>
                                      <div class="subheading	 justify-start red--text">Genel Toplam</div>
                                    </v-layout>
                                  </v-flex>
                                  <v-flex pa-1 xs6 md6>
                                    <v-layout justify-end>
                                      <div class="justify-end align-center  red--text fill-height subheading ">

                                        {{Bilet.TutarBilgileri.NetTutar.NetTutar | moneyformat}}{{getparabirimi()}}
                                      </div>
                                    </v-layout>
                                  </v-flex>
                                </v-layout>
                              </v-flex>




                            </v-layout>
                            <v-divider></v-divider>
                          </v-flex>

                        </v-layout>
                      </v-flex>

                    </v-layout>

                  </v-card>


                </v-flex>

              </div>
            </v-layout>

          </v-flex>

        </v-layout>
      </v-container>

      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>



    </v-card>
  </div>
</template>

<script>
  import auth from '../../../api/auth'
  import helpers from "@/components/app/customcomp/helpers.js"

  import VeLine from 'v-charts/lib/line.common'
  import VeBar from 'v-charts/lib/bar.common'
  import VePie from 'v-charts/lib/pie.common'
  import VeHistogram from 'v-charts/lib/histogram.common'
  import tarihcomp from '../customcomp/tarihim'


  export default {
    data() {
      return {
        havayolobilgisi: null,
        text1: null,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,

        Bilet: {
          GenelBilgileri: {
            ArkmanUsers: '',
            SirketKodu: '',
            BiletNo: '',
            Formno: '',
            HavaYoluKodu: null,
            UcusTipi: '',
            SiparisNo: 0,
            MusteriKodu: {
              Kod: '',
              Uyari: '',
              BilgiNotu: ''
            },
            KesenKisi: '',
            YolcuAdi: '',
            Parkurlar: {
              Parkur1: '',
              Parkur2: '',
              Parkur3: '',
              Parkur4: '',
              Parkur5: '',
            },
            Classlar: {
              Class1: '',
              Class2: '',
              Class3: '',
              Class4: '',
              Class5: '',
            },
            FiyatTur: 'AD', //enum deger
            Referans: {
              Kod: ''
            },
            YolcuAdet: 1,
            Baglantili: false,
            PnrNo: '',
            RezervasyonVeren: '',
            RezervasyonAlan: '',
            Status: null, //enum
            Acente: '',
            AcenteKodu: '',
            ExBiletNo: '',
            ExBiletHY: '',
            ClassTip: 'E', //enum
            BiletYon: 'T', //enum
            DepartmanKod: '',
            Crs: 'Manuel', //enum
            Masraf: {
              Code: ''
            },
            Email: '',
            BiletTel: '',
          },
          TarihBilgileri: {
            KesimTarihi: null,
            SatisTarihi: null,
            IptalTarihi: null,
            IadeTarihi: null,
            OdemeTarihi: null,
          },
          UcusBilgileri: {
            UcusTarihi: null,
            UcusNo1: null,
            UcusNo2: null,
            UcusDonusTarihi: null,
            UcusDonusNo1: null,
            UcusDonusNo2: null,
            UcusListesi: []
          },
          FaturaBilgileri: {
            FaturaTarihi: null,
            FaturaSeri: null,
            FaturaNo: 0,
            EfaturaBilgileri: {
              FaturaNo: null,
              Guid: null,
              FaturaDurumu: null,
              SanalFaturaNo: null,
              GercekFaturaNo: null,
              BasimTarihi: null,
              Kullanici: null,
              GonderimSekli: 0,
              InternetSatis: 0,
              WebAdresi: null,
              OdemeSekli: 0,
              OdemeSekliAciklama: null,
              OdemeAraci: null,
              OdemeTarihi: null
            },
            AlisFaturaNo: null,
            ProformaSeri: null,
            ProformaNo: 0,
            ProformaTarihi: null,
            SatisFaturaID: null,
            MaliyetFaturaID: null,
            AlisFaturaTarihi: null,
            AlisFatNo: null,
            FaturaOtomatik: 0,
            IstinaKod: null,
            KdvKod: null,
          },
          TutarBilgileri: {
            Doviz: {
              DovizKod: ''
            },
            Kur: 1,
            NetTutar: {
              NetTutar: 0,
              NetTutarSatisDoviz: 0,
              NetTutarAlisDoviz: 0,
              NetTutarKdv: 0,
            },
            Tutar: {
              Tutar: 0,
              TutarSatisDoviz: 0,
              TutarAlisDoviz: 0,
              TutarKdv: 0,
            },
            PtaTutar: {
              PtaTutar: 0,
              PtaSatisDoviz: 0,
              PtaAlisDoviz: 0,
              PtaKdv: 0
            },
            AlanVergiTutar: {
              AlanVergiTutar: 0,
              AlanVergiSatisDoviz: 0,
              AlanVergiAlisDoviz: 0,
              AlanVergiKdv: 0,
            },
            CharterTutar: {
              CharterTutar: 0,
              CharterSatisDoviz: 0,
              CharterAlisDoviz: 0,
              CharterKdv: 0
            },
            YFFTutar: {
              YFFTutar: 0,
              YFFDoviz: 0,
              YFFKdv: 0
            },
            ServisTutar: {
              ServisTutar: 0,
              ServisDoviz: 0,
              ServisKdv: 0
            },
            DigerServisTutar: {
              DigerServisTutar: 0,
              DigerServisDoviz: 0,
              DigerServisKdv: 0
            },
            IskontoTutar: {
              IskontoYuzde: 0,
              IskontoTutar: 0,
              IskontoDoviz: 0,
              IskontoKdv: 0
            },
            TaxTutar: {
              TaxTutar: 0,
              TaxSatisDoviz: 0,
              TaxAlisDoviz: 0,
              TaxKdv: 0
            },
            CezaTutar: {
              CezaTutar: 0,
              CezaSatisTutar: 0,
              CezaAlisTutar: 0,
              CezaKdv: 0
            },
            KaTutar: {
              KaTutar: 0,
              KaDoviz: 0,
              KaKdv: 0
            },
            ReserveTutar: {
              ReserveYuzde: 0,
              ReserveTutar: 0,
              ReserveDoviz: 0,
              ReserveKdv: 0
            }
          },

          OdemeBilgileri: {
            SatisSekli: 'K', //enum
            KomisyonTip: '', //enum
            HYOran: 0,
            GSAOran: 0,
            KrediliTutar: 0,
            KrediliDoviz: 0,
            PesinTutar: 0,
            PesinDoviz: 0,
            KrediKartTutar: 0,
            KrediKartDoviz: 0,
            KrediKartBilgi: {
              KrediKartNo: '',
              KrediKartAy: '',
              KrediKartYil: '',
              KrediKartCins: '',
              KrediKartTip: ''
            },
            AlisServisTutar: {
              AlisServisTutar: 0,
              AlisServisDoviz: 0,
              AlisServisKdv: 0
            },
            HavaYoluTutar: 0,
            HavaYoluKdv: 0,
            Csc: false,
            BankaBilgileri: {
              PosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                }
                //public List<BankaPosTaksit> Taksitler { get; set; }
              },
              ServisPosKod: {
                BankaPosID: 0,
                SirketKodu: 0,
                PosKodu: '',
                Aciklama: '',
                MuhasebeKodlar: {
                  MuhasebeKodu: '',
                  CMuhasebeKodu: '',
                  FDisAktarimCariKodu: '',
                  FDisAktarimMuhKodu: '',
                  CDisAktarimCariKodu: '',
                  CDisAktarimMuhKodu: '',
                  ServisMuhasebeKodu: '',
                  ServisDisAktarimCariKodu: '',
                  ServisDisAktarimMuhKodu: ''
                },
                Parametreler: {
                  ID: 0,
                  Banka: {
                    BankaID: 0,
                    SirketKodu: 0,
                    BankaKod: '',
                    BankaAdi: '',
                    Cari: {
                      Kod: ''
                    },
                    BankaKisaKod: '',
                    Tip: 0
                  },
                  PosMuhKodu: '',
                  PuanCariKodu: '',
                  SozlesmeBaslangic: null,
                  SozlesmeBitis: null,
                  Aktif: '',
                  VadeTip: '',
                  UyelikTutar: 0,
                  UyelikOran: 0,
                  Kota: 0,
                  KotaGun: 0,
                  KotaCezaTutar: 0,
                  KotaCezaOran: 0,
                  VadeSabitGun: 0,
                  VadeFarkSabit: 0,
                  KotaKod: '',
                  TerminalID: '',
                  UyeIsYeriID: '',
                  UserName: '',
                  UserPass: '',
                  PosType: 0,
                  StoreKey: '',
                },
                Taksitler: []
              },

              ServisPosTutar: 0,
              TaksitKod: '',
              ServisTaksitKod: '',
              TaksitKodLabel: '',
              ServisTaksitKodLabel: '',
              PuanTutar: 0
            },
            Slipkod: '',
            MakbuzNo: '',
          },
          DigerBilgileri: {
            SaveTime: null,
            Entegre: false,
            BiletTanim: '',
            eservedTutar1: 0,
            ExIcDis: '',
            EntegreTablo: '',
            GrossTutar: 0,
            ExIcDis: '',
            CharterPtaKodu: '',
            pArkmanEntegre: '',
            PinKodu: '',
            RezervasyonID: '',
            SiparisID: '',
            CKLogID: 0,
            ExIcDis: '',
            ParkurTip: '',
            DServisKod1: '',
            DServisKod2: '',
            KKEnt: '',
            SatisSapEntegre: '',
            MaliyetSapEntegre: '',
            KisiID: 0,
            ExIcDis: '',
            // EntegrasyonID: guid değişkeni
            UserID: 0,
            ExIcDis: ''
          },
          TanimBilgileri: {
            ServisKod: '',
            AnalizKod: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar: 0,
            AnalizDoviz: 0,
            AnalizKod1: {
              SirketKodu: 0,
              AnalizKod: '',
              AnalizAdi: '',
              AnalizTutar: 0,
              AnalizOran: 0,
            },
            AnalizTutar1: 0,
            AnalizDoviz1: 0,
            TcKimlikNolar: {
              TcNo1: '',
              TcNo2: '',
              TcNo3: '',
              TcNo4: '',
              TcNo5: ''
            },
            Aciklamalar: {
              Aciklama1: '',
              Aciklama2: '',
              Aciklama3: '',
              Aciklama4: '',
              Aciklama5: '',
              Aciklama6: '',
              Aciklama7: '',
            },
            MilKodu: {
              MilKoduOde: '',
              MilKoduYolcu: '',
              MilAdet: 0,
              MilTutar: 0
            },
            MusteriPersonel: {
              PersonelUcan: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              },
              PersonelSponsor: {
                ID: 0,
                SirketKodu: 0,
                SirketAdi: '',
                MasrafYeri: '',
                SicilNo: '',
                Adi: '',
                Soyadi: '',
                CalismaYeri: '',
                Bolum: '',
                IcSeyahat: '',
                DisSeyahat: '',
                IsAlani: '',
                Siparis: '',
                Cari: {
                  Kod: ''
                },
                KapatAc: false,
                Email: '',
                Tel: ''
              }
            },
            YolcuCrm: {
              CrmYolcu: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              },
              CrmRezervasyon: {
                Ref: 0,
                Adi: '',
                Soyadi: '',
                Tel: '',
                Gsm: '',
                Email: '',
                TCKimlikNo: '',
                ID: 0
              }
            },
            ProfilID: 0,
            SablonID: 0,
            Bolum: '',
            EventID: '',
            ExAciklamalar: {
              ID: 0,
              SirketKodu: 0,
              Biletno: '',
              HavayoluKod: '',
              EmployeeId: '',
              DepartmentId: '',
              CostCenter: '',
              ClientId: '',
              DkNumber: '',
              WwId: '',
              BusinessUnit: '',
              CompanyCode: '',
              SiteCode: '',
              PurposeOt: '',
              PcNumber: '',
              NoHotelBc: '',
              TripApprover: ''
            }
          },
          AyrintiOdemeBilgileri: [],
          NotlarBilgileri: {
            SirketKodu: 0,
            BiletNo: '',
            FormNo: '',
            Aciklama1: '',
            Aciklama2: '',
            Segment1: '',
            Segment2: '',
            Segment3: '',
            Segment4: '',
            Segment5: '',
            RefFare: 0,
            LowFare: 0,
            RealCode: '',
            DateofRes: null,
            MarketCode: '',
            TicketSuffix: '',
            VendorNumber: '',
            ReasonCode: '',
            CRSGDS: '',
            SubPruductCode: '',
            TicketTypeInd: false,
            TourCode: '',
            AlternatifTutar1: 0,
            AlternatifTutar2: 0,
            AlternatifTutar3: 0,
            Anlasmali: false,
            Esnek: false,
            KarbonSalinimi: 0,
            Mil1: 0,
            Mil2: 0,
            Mil3: 0,
            Mil4: 0
          },

          TaksitBilgileri: {
            ID: 0,
            SirketKodu: 0,
            BiletNo: '',
            HavaYoluKodu: '',
            MakbuzNo: '',
            CCNo1: '',
            Tip1: '',
            Ay1: 0,
            Yil1: 0,
            Tutar1: 0,
            Iade1: 0,
            Taksit1: 0,
            TVade1: null,
            PosKodu1: '',
            CCNo2: '',
            Tip2: '',
            Ay2: 0,
            Yil2: 0,
            Tutar2: 0,
            Iade2: 0,
            Taksit2: 0,
            TVade2: null,
            PosKodu2: '',
            CCNo3: '',
            Tip3: '',
            Ay3: 0,
            Yil3: 0,
            Tutar3: 0,
            Iade3: 0,
            Taksit3: 0,
            TVade3: null,
            PosKodu3: '',
            CCNo4: '',
            Tip4: '',
            Ay4: 0,
            Yil4: 0,
            Tutar4: 0,
            Iade4: 0,
            Taksit4: 0,
            TVade4: null,
            PosKodu4: '',
            PesinSatisTutari: 0,
            PesinIadeTutari: 0,
            SlipKod1: '',
            SlipKod2: '',
            SlipKod3: '',
            SlipKod4: '',
            OdemeFaturaId: '',
            OdemeSapEntegre: '',
          }
        },





        Current: {
          Unvan: null,
          Tel1: null,
          Tel2: null,
          Tel3: null,
          Email: null,
          GSM: null,
          Web: null,
          Adres1: null,
          IlceIl: null,
          TesAdres: null
        },
        ListInput: {
          SirketKodu: 1,
          BaslangicTarihi: '2020-02-01',
          BitisTarihi: getDateNow(),
          Carikod: null,
          HavaYoluKodu: null,
          FormNo: null,
          BiletNo: null,
          TextSearch: null,
          Paging: {
            SayfaNo: 1,
            VeriAdet: 50,
            SiralamaTip: 'SalesDate'
          },
          Filtreler: {
            CariKod: 'ARKMAN',
            Havayollari: [],
            Parkurlar: [],
            HatTipi: [], // I : iç hat, D: Dış hat, B: Bsp
            BiletTipi: 'S', // S: Satış, I: Iade, V : Void
            Ucus1: null,
            Ucus2: null,
            KesenKisi: null,
            PosKod: null,
            DekontBas: false,
            KrediKartNo: null,
            GiderPusulasi: 0, // 0: seçim yok, 1 : basılmış, 2 : basılmamış
            AcentaFatNo: 0, // 0 : seçim yok, 1 : fatura olan, 2 : fatura olmayan
            IadeFatura: false,
            GeciciCari: 0, // 0 : hepsi, 1 : geci haric, 2 : sadece gecici
            FaturaStatus: 0, // 0 : hepsi, 1 : faturalanmamışlar, 2 : faturalanmışlar
            BaslangicTutar: 0,
            BitisTutar: 0,
            TutarTip: 0 // 0 : NetTutar, 1 : Bilet Tutar, 2 : Servis Tutar, 3 : Iskonto Tutar
          }
        },

        loading1: true,
        load1: true,
        satis: 0,
        iade: 0,
        voidbilet: 0,
        toplamsatis: 0,
        toplamiade: 0,
        toplamservis: 0,
        toplamborc: 0,
        vadesigelenborc: 0,
        faturaedilmisbilet: 0,
        faturaedilmemisbilet: 0,
        gecicibilet: 0,

        kagitfatura: 0,
        earsivgonderilen: 0,
        earsivgonderilmeyen: 0,
        efaturagonderilen: 0,
        efaturagonderilmeyen: 0,

        chartSettings: {
          title: {
            show: true,
            text: 'eaieaei'
          },
          label: {
            show: true
          },
          axisSite: {
            right: ['growthRate']
          },
          yAxisType: ['KMB'],
          yAxisName: ['Adet']
        },
        drawer: null,

        currentDebtTotal: 0,
        currentCreditTotal: 58,
        debtTotal: 0,
        creditTotal: 0,
        valid: true,
        tooltip: false,
        el: null,
        charthavayolunagore: {
          rows: [],
          columns: ['firma', 'satis', 'iade'],
        },

        chartsatistipinegore: {
          columns: ['tarih', 'İç Hat Satış Adet', 'İç Hat İade Adet', 'Dış Hat Satış Adet', 'Dış Hat İade Adet'],
          rows: []
        },



        chartData: {
          columns: ['date', 'PV', 'Order', 'OrderRate'],
          rows: [{
              'date': 'Satılan Bilet Sayısı',
              'PV': 1393,
              'Order': 1093,
              'OrderRate': 0.32
            },
            {
              'date': '1/2',
              'PV': 3530,
              'Order': 3230,
              'OrderRate': 0.26
            },
            {
              'date': '1/3',
              'PV': 2923,
              'Order': 2623,
              'OrderRate': 0.76
            },
            {
              'date': '1/4',
              'PV': 1723,
              'Order': 1423,
              'OrderRate': 0.49
            },
            {
              'date': '1/5',
              'PV': 3792,
              'Order': 3492,
              'OrderRate': 0.323
            },
            {
              'date': '1/6',
              'PV': 10093,
              'Order': 4293,
              'OrderRate': 0.78
            }
          ]
        },

        chartsatis: {
          columns: ['tip', 'İç Hat Satış', 'İç Hat İade', 'Dış Hat Satış', 'Dış Hat İade'],
          rows: [{
              'tip': 'Aralık',
              'İç Hat Satış': 180,
              'İç Hat İade': 18,
              'Dış Hat Satış': 120,
              'Dış Hat İade': 20
            }, {
              'tip': 'Ocak',
              'İç Hat Satış': 150,
              'İç Hat İade': 55,
              'Dış Hat Satış': 110,
              'Dış Hat İade': 40,
            },

          ]
        },

        charthavayolu: {
          columns: ['firma', 'satis', 'iade'],
          rows: [{
            'firma': 'TK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'H9',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'KK',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'OHY',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'XQ',
            'satis': 0,
            'iade': 0
          }, {
            'firma': 'Diğer',
            'satis': 0,
            'iade': 0
          }]
        },

        colors: ['#03A9F4', '#F44336'],


        chartsatisseklinegore: {

          columns: ['tipi', 'adet'],
          rows: []

        },
      }
    },
    beforeMount: beforeMount,
    methods: {

      yazdir(divName) {

        // var mywindow = window.open('', 'PRINT', 'height=500,width=700');

        // mywindow.document.write('</head>');
        // mywindow.document.write('<style>');
        // //yazdırılmayacak alanlar için css ekliyorum
        // mywindow.document.write('@media print{.no-print {display:none !important;}}');
        // mywindow.document.write('</style>');
        // mywindow.document.write('<body >');
        // mywindow.document.write(document.getElementById(divName).innerHTML);
        // mywindow.document.write('</body></html>');

        // mywindow.document.close(); // necessary for IE >= 10
        // mywindow.focus(); // necessary for IE >= 10*/

        // mywindow.print();
        // mywindow.close();

        // return true;




const prtHtml = document.getElementById(divName).innerHTML;

// Get all stylesheets HTML
let stylesHtml = '';
for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
  stylesHtml += node.outerHTML;
}

// Open the print window
const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

WinPrint.document.close();
WinPrint.focus();
WinPrint.print();
WinPrint.close();


      },
      havayolubul(val) {
        this.havayolobilgisi = val.Code

        this.$http.post(auth.API_URL + 'api/TicketDefinitons/AirlineSearch', val, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.havayolobilgisi = response.body[0].Title

        }, (response) => {

          this.havayolobilgisi += '-'

        })

      },
      getparabirimi() {
        return helpers.getparabirimi()
      },
      BiletListele,
      getList: getList,
      getDateNow: getDateNow
    },
    components: {
      tarihcomp,
      VeLine,
      VeBar,
      VePie,
      VeHistogram
    },

    mounted() {

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));



      if (this.$route.query.isl == 'get') {

        var biletparams = {
          SirketKodu: credentials.CariBilgi.SirketKodu,
          BiletNo: this.$route.query.biletno,
          HavaYoluKodu: this.$route.query.hyolukod,
          UcusTipi: this.$route.query.ucustipi
        }




        this.$http.post(auth.API_URL + 'api/Ticket/TicketGet', biletparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {







          this.Bilet.GenelBilgileri.Referans.Kod = String(response.body.GenelBilgileri.Referans.Kod)

          if (response.body.GenelBilgileri.MusteriKodu.Kod != null) {
            this.Bilet.GenelBilgileri.MusteriKodu.Kod = response.body.GenelBilgileri.MusteriKodu.Kod
          }

          this.postaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.TaksitKod

          this.servistaksitsayi = response.body.OdemeBilgileri.BankaBilgileri.ServisTaksitKod






          this.Bilet = response.body

          var params = {
            Code: null,
            FormNo: null,
            Search: this.Bilet.GenelBilgileri.HavaYoluKodu,
          }

          this.havayolubul(params);





          var ucus = [{
              ID: 89554,
              SirketKodu: 1,
              BiletNo: "2403256913",
              Formno: null,
              ParkurNo: 1,
              Parkur: "ESB",
              UcusTarihi: "2020-02-02T00:00:00",
              UcusNo: "2153",
              UcusHY: "TK",
              UcusSaat: "16:35",
              UcusClass: "B",
              Aktarma: false,
              VarisTarihi: "0001-01-01T00:00:00",
              VarisSaat: "17:55",
              FareBases: "0",
              VarisParkur: null
            },
            {
              ID: 89554,
              SirketKodu: 1,
              BiletNo: "2403256913",
              Formno: null,
              ParkurNo: 1,
              Parkur: "ESB",
              UcusTarihi: "2020-02-02T00:00:00",
              UcusNo: "2153",
              UcusHY: "TK",
              UcusSaat: "16:35",
              UcusClass: "B",
              Aktarma: false,
              VarisTarihi: "0001-01-01T00:00:00",
              VarisSaat: "17:55",
              FareBases: "0",
              VarisParkur: null
            }
          ]

          //this.Bilet.UcusBilgileri.UcusListesi = ucus



          if (response.body.GenelBilgileri.Acente == 'A') {
            this.baslik_mesaji = '*** Bu bilet ' + this.Bilet.GenelBilgileri.AcenteKodu +
              ' acentasından alınmıştır'
          } else {
            this.baslik_mesaji = ""

          }




        }, (response) => {
          if (response.status === 0) {
            console.log('')


            this.text1 = 'Service Unavailable'
            this.snackbar = true
          } else {
            console.log('')



            this.text1 = 'Service Unavailable'
            this.snackbar = true
          }
        })





      } else {
        this.text1 = "Hatalı url, işlem yapılamıyor"
        this.snackbar = true
      }


    },
    filters: {
      aktarma: function (val) {
        if (val == true) {
          return 'Var'
        } else {
          return 'Yok'
        }
      },

      ucustipi: function (val) {

        if (val == 'I') {

          return 'İç Hat'

        } else if (val == 'D') {
          return 'Dış Hat'

        } else if (val == 'B') {
          return 'BSP'
        }

      },
      bilettutar: function (item) {
        var tutar = item.Tutar.Tutar + item.ReserveTutar.ReserveTutar + item.DigerServisTutar.DigerServisTutar
        return helpers.moneyformat(tutar);
      },

      toplamservis: function (item) {
        var toplamservis = item.ServisTutar.ServisTutar - item.IskontoTutar.IskontoTutar
        return helpers.moneyformat(toplamservis);
      },
      toplamvergi: function (item) {
        var toplamvergi = item.AlanVergiTutar.AlanVergiTutar + item.YFFTutar.YFFTutar +item.TaxTutar.TaxTutar
        return helpers.moneyformat(toplamvergi);
      },
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      },
      gethavayolu: function (val) {
        return val.HavayoluKodu + '-' + val.HavayoluAdi
      }
    },
  }






  function BiletListele() {




    var Params = this.ListInput;


    this.$http.post(auth.API_URL + 'api/Ticket/TicketList', Params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      //  this.itemsticket = response.body






    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
        this.load1 = true
        this.progress = false
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true

        this.load1 = true
        this.progress = false

      }
    })




  }




  function getList() {

    if (this.$refs.formsalesreport.validate()) {
      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      this.progress = true
      this.SummaryInfo.SirketKodu = credentials.SirketKodu
      var params = this.SummaryInfo
      this.load1 = false
      this.$http.post(auth.API_URL + 'api/TicketReport/SummaryInfoList', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        var yenikayitdizi = []

        // grafik1
        if (response.body.HavayoluAdetList.length > 0) {
          response.body.HavayoluAdetList.forEach(element => {
            var yenikayit = {
              firma: element.HavaYoluKodu,
              satis: element.Adet,
              iade: element.IadeAdet
            }
            yenikayitdizi.push(yenikayit);
          });

          this.charthavayolunagore.rows = yenikayitdizi
        } else {
          var yenikayit = {
            firma: 0,
            satis: 0,
            iade: 0
          }
          yenikayitdizi.push(yenikayit);
          this.charthavayolunagore.rows = yenikayitdizi

        }

        //grafik3
        yenikayitdizi = [];

        if (response.body.GunSatisList.length > 0) {

          response.body.GunSatisList.forEach(element => {
            console.log('girdi')
            var yenikayit2 = {
              'tarih': element.TarihStr,
              'İç Hat Satış Adet': element.SatisAdetIcHat,
              'İç Hat İade': element.IadeAdetIcHat,
              'Dış Hat Satış Adet': element.SatisAdetDisHat,
              'Dış Hat İade Adet': element.IadeAdetDisHat
            }
            yenikayitdizi.push(yenikayit2);

          });

          this.chartsatistipinegore.rows = yenikayitdizi


        } else {

          var yenikayit2 = {
            'tarih': 0,
            'İç Hat Satış Adet': 0,
            'İç Hat İade': 0,
            'Dış Hat Satış Adet': 0,
            'Dış Hat İade Adet': 0
          }
          yenikayitdizi.push(yenikayit2);

          this.chartsatistipinegore.rows = yenikayitdizi
        }






        //grafik2

        yenikayitdizi = [];

        var satistipi = {
          'tipi': 'Kredili',
          'adet': response.body.SatisSekliAdet.KrediliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'R-KK',
          'adet': response.body.SatisSekliAdet.RKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'F-KK',
          'adet': response.body.SatisSekliAdet.FKartliAdet
        };
        yenikayitdizi.push(satistipi);

        satistipi = {
          'tipi': 'C-KK',
          'adet': response.body.SatisSekliAdet.CKartliAdet
        };
        yenikayitdizi.push(satistipi);

        this.chartsatisseklinegore.rows = yenikayitdizi;

        this.progress = false
        this.load1 = true




        this.satis = response.body.SatisAdet;
        this.iade = response.body.IadeAdet;
        this.voidbilet = response.body.VoidAdet;
        this.toplamsatis = response.body.BiletSatisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamiade = response.body.BiletIadeTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.toplamservis = response.body.SatisServisTutari.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
        this.vadesigelenborc = response.body.BorcBilgi.VadesiGecenBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g,
          '$1,')
        this.toplamborc = response.body.BorcBilgi.ToplamBorc.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
        this.faturaedilmisbilet = response.body.FaturalanmisBiletAdet;
        this.faturaedilmemisbilet = response.body.FaturalanmamisBiletAdet;
        this.gecicibilet = response.body.GecicideAdet;
        this.kagitfatura = response.body.FaturaTipAdet.KagitFaturaAdet
        this.earsivgonderilen = response.body.FaturaTipAdet.EArsivGonderilenAdet
        this.earsivgonderilmeyen = response.body.FaturaTipAdet.EArsivGonderilmeyenAdet
        this.efaturagonderilen = response.body.FaturaTipAdet.EFaturaGonderilenAdet
        this.efaturagonderilmeyen = response.body.FaturaTipAdet.EFaturaGonderilmeyenAdet




      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.load1 = true
          this.progress = false
        }
      })

    }
  }



  function beforeMount() {

  }






  function getDateNow() {
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }
    today = yyyy + '-' + mm + '-' + dd
    return today
  }
</script>

<style>
  .project.complete {
    border-left: 4px solid #039BE5;
  }

  .project.ongoing {
    border-left: 4px solid orange;
  }

  .project.overdue {
    border-left: 4px solid tomato;
  }

  @media print {
    .no-print {
      display: none !important;
    }
  }

</style>